import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import cn from 'classnames';
import BN from 'bignumber.js';

import styles from '../../styles/main/main.module.scss';
import stylesParent from '../../styles/frame/frame.module.scss';
import Tooltip from '../../../../../../components/tooltip';
import RfuelIcon from '../../../../../../assets/images/tokens/rfuel.svg';
import Header from '../../../../../../components/Stake/header';
import * as rfuelStakeActions from '../../../../../../actions/rfuel-stake-actions';
import { formatToken } from '../../../../../../helpers/token-helper';
import { RFUEL } from '../../../../../../constants/blockchain-constants';
import { toPowerOf } from '../../../../../../blockchain/config';
import WithdrawCountdown from '../../../../../../components/withdraw-countdown';
import StakeInfo from '../../../../../../components/Stake/stake-info';

const unstakeTooltip = `
First unstake all currently staked RFUEL. Next claim any unclaimed rewards you have immediately after unstaking 
to avoid delays (claiming rewards midway through the 8 day unstaking timer will reset the timer to 8 days until 
you can withdraw, so make sure to do both actions one after the other for fastest withdrawal time). 
Lastly after 8 days, withdraw your unstaked and claimed RFUEL.`;

const Main = () => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.basic.dark);

  const { stakeBalance, unstakedBalance, unstakedTime, rewardEarned, rewardBalance } = useSelector(
    (state) => state.RFUELstake.stake,
  );
  const isDisabledWithdraw =
    unstakedTime > Date.now() / 1000 ||
    new BN(unstakedBalance).isLessThan(new BN(0.1).times(toPowerOf));

  const text = (
    <div style={{ color: 'white', padding: '10px' }}>
      <span style={{ textAlign: 'center', fontWeight: 600 }}>
        This current RFUEL staking pool is closing and migrating to an upgraded, auto-compunding
        pool.
      </span>
      <div style={{ textAlign: 'left' }}>
        <br /> You will need to: <br />
        <div style={{ padding: '0 10px' }}>
          1. Claim your rewards <br /> 2. Unstake your RFUEL <br /> 3. After 8 days withdraw your
          RFUEL <br /> 4. (optional) Stake your RFUEL tokens into the new upgraded staking pool.
        </div>
      </div>
    </div>
  );
  return (
    <>
      <Header
        icon={RfuelIcon}
        title='RFUEL-staking'
        style={{ width: '500px' }}
        // onClickHistory={() => dispatch(rfuelStakeActions.showHistory())}
      />
      <div className={cn({ [styles.dark]: dark })}>
        <div className={styles.unstakeContainer}>
          <div className={styles.stakeMoreWrapper}>
            <StakeInfo type={RFUEL} text={text} />
          </div>
          <Tooltip
            className={styles.unstakeTooltip}
            label='Step 1: Claim Unclaimed RFUEL Rewards'
            text={<div className={stylesParent.tooltipText}>{unstakeTooltip}</div>}
          />
          <div className={styles.unstakeControls}>
            <div className={styles.unstakeControlsText}>
              <div className={cn(styles.unstakeControlValue, styles.active)}>
                <span>
                  {formatToken(new BN(rewardEarned).plus(rewardBalance).toString(10))} RFUEL
                </span>
              </div>
            </div>
            <div className={styles.unstakeButtons}>
              <Button
                className={styles.secondaryButton}
                disabled={Number(rewardBalance) === 0 && Number(rewardEarned) === 0}
                onClick={() => dispatch(rfuelStakeActions.claimRewardsSend('unstake'))}
                variant='outlined'
              >
                Claim
              </Button>
            </div>
          </div>
          <br />
          <Tooltip
            className={styles.unstakeTooltip}
            label='Step 2: Unstake your RFUEL'
            text={<div className={stylesParent.tooltipText}>{unstakeTooltip}</div>}
          />
          <div className={styles.unstakeControls}>
            <div className={styles.unstakeControlsText}>
              <div className={cn(styles.unstakeControlValue, styles.active)}>
                <span>{formatToken(new BN(stakeBalance).toString(10))} RFUEL</span>
              </div>
            </div>
            <div className={styles.unstakeButtons}>
              <Button
                className={styles.secondaryButton}
                disabled={new BN(stakeBalance).isLessThan(new BN(1).times(toPowerOf))}
                onClick={() => dispatch(rfuelStakeActions.unstakeSettings())}
                variant='outlined'
              >
                Unstake
              </Button>
            </div>
          </div>
          <br />
          <Tooltip
            className={styles.unstakeTooltip}
            label='Step 3: Withdraw RFUEL'
            text={<div className={stylesParent.tooltipText}>{unstakeTooltip}</div>}
          />
          <div className={styles.unstakeControls}>
            <div className={styles.unstakeControlsText}>
              <div className={cn(styles.unstakeControlValue, styles.active)}>
                <span>
                  {formatToken(unstakedBalance)} {RFUEL}
                </span>
              </div>
              <div className={styles.unstakeControlDays}>
                <WithdrawCountdown
                  date={unstakedTime * 1000}
                  onDone={() => dispatch(rfuelStakeActions.getUntakedTime())}
                />
              </div>
            </div>
            <Button
              className={styles.secondaryButton}
              disabled={isDisabledWithdraw}
              onClick={() => dispatch(rfuelStakeActions.withdrawUnstakedDetails())}
              variant='outlined'
            >
              Withdraw
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
